import React, { createContext, useContext, useState, useEffect } from "react";
import {deleteJwt, getJwt, setJwt} from "./Auth";

interface AuthContextType {
    token: string | null;
    login: (token: string, expiresIn: number) => void;
    logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [token, setToken] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const savedToken = getJwt();
        if (savedToken) {
            setToken(savedToken);
        }
        setLoading(false);
    }, []);

    const login = (jwt: string, expiresIn: number) => {
        setJwt(jwt, expiresIn);
        setToken(jwt);
    }

    const logout = () => {
        deleteJwt();
        setToken(null);
    }

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <AuthContext.Provider value={{ token, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export function useAuth(): AuthContextType {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error("useAuth must be used within the AuthProvider");
    }
    return ctx;
}